import { render, staticRenderFns } from "./SkipLinks.vue?vue&type=template&id=223f0f50&scoped=true&"
import script from "./SkipLinks.vue?vue&type=script&lang=js&"
export * from "./SkipLinks.vue?vue&type=script&lang=js&"
import style0 from "./SkipLinks.vue?vue&type=style&index=0&id=223f0f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f0f50",
  null
  
)

export default component.exports